<div class="app__container">
	@if (!isLoading && isAuthenticated) {
		<ax-page-template></ax-page-template>
	} @else {
		<ax-loader [isFullPage]="true" [loaderText]="'Loading Warehouse Management'"></ax-loader>
	}
</div>
